// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3e986","rightAdornment":"Header_rightAdornment__OFzjM"};